//import packages from node modules
import React,{useState,useEffect,useCallback,useRef} from 'react'
import {useSelector,useDispatch} from 'react-redux'
import {withRouter} from 'react-router-dom'
import PropTypes from 'prop-types'
import {
  ADD_PRODUCT_PAGE,
  EDIT_PRODUCT_PAGE,
  LOCALE_STRING_OPTIONS,
  LOCALE_LANG_OPTIONS
} from '../../../../utilities/function/common'

import {
  getCycle,
  getPriceByBillingCycleID
} from '../../../../utilities/function/billingCycle'

import {
  getCID,
  getDataFromURL,
  getPageByURL
} from '../../../../utilities/function/urlparams'

import {
  getAttributes
} from '../../../../utilities/function/configuration'

import CustomSlider from '../../slider'
import { addItemToCart, editProductPage, updateConfig } from '../../../../app/action'
import Heading from '../../typography/heading'
import Description from '../../typography/description'
import SolidButton from '../../button/solidbutton'


//sub component: Email Hosting Slider
let EmailHostingSlider = (props) =>{

  const {location,history} = props
  const dispatch = useDispatch()

  const {configurations,cartData} = useSelector(state=>({
    configurations: state.app.configurations,
    cartData: state.app.cartData
  }))

  const cid = getCID(getDataFromURL(location.search))
  const productConfig = configurations[cid]

  const [value,setValue] = useState(1)
  const renderMailbox = () =>{
    if(value){
      return (
        <div className={'of-email-hosting-slider__mailbox'}>
          <span className={'of-email-hosting-slider__mailbox-value text-font-1-100'}>{value}</span>
          <span className={'of-email-hosting-slider__mailbox-label text-font-1-100'}>{value===1?'Mailbox':'Mailboxes'}</span>
        </div>
      )
    }
    return (<></>)
  }
  const renderPrice = () =>{
    if(productConfig && productConfig.selectedProduct && getAttributes(productConfig.selectedProduct)){
      const {billing_cycle_id} = productConfig
      const {price} = getAttributes(productConfig.selectedProduct)
      const selectedPrice = getPriceByBillingCycleID(price,billing_cycle_id)
      if(selectedPrice){
        const getTotalPrice = () => {
          if(selectedPrice.price && parseFloat(selectedPrice.price)){
            const total = value * parseFloat(selectedPrice.price)
            if(total){
              return total.toLocaleString(LOCALE_LANG_OPTIONS,LOCALE_STRING_OPTIONS)
            }
          }
          return undefined
        }
        return (
          <div className={'of-email-hosting-slider__price'}>
            <span className={'of-email-hosting-slider__price-value text-font-1-100'}>${getTotalPrice()}</span>
            <span className={'of-email-hosting-slider__price-label text-font-3-100'}>{getCycle(selectedPrice.name)}</span>
          </div>
        )
      }
    }

    return (<></>)
  }

  const pageType = getPageByURL(location.search)

  const initFlag = useRef(false)
  const initEmailHostingSlider = useCallback(()=> {
    if(!initFlag.current){
      if(productConfig && productConfig.quantity){
        setValue(productConfig.quantity)
      }else{
        setValue(1)
        updateConfig(configurations,cid,{
          quantity: 1
        },dispatch)
      }
      initFlag.current = true
    }
  },[setValue,productConfig,configurations,cid,dispatch])



  useEffect(()=>{
    initEmailHostingSlider()
  },[initEmailHostingSlider])

  const renderButton = () => {
    if(pageType===ADD_PRODUCT_PAGE){
      return (
        <SolidButton className={'of-email-hosting-slider__button'} onClick={()=>{
          addItemToCart(productConfig,dispatch,history,configurations,location)
        }}>Add To Cart</SolidButton>
      )
    }else if(pageType===EDIT_PRODUCT_PAGE){
      return (
        <div className={'of-gsuite-config-form__row'}>
          <SolidButton onClick={()=>{
            editProductPage(cid,configurations,cartData,dispatch,location,history)
          }} className={'of-gsuite-config-form__button primary-background-1-100'}>Update</SolidButton>
        </div>
      )
    }
    return (<></>)
  }

  return (
    <div className={'of-email-hosting-slider clearfix'}>
      <div className={'of-email-hosting-slider__wrapper'}>
        {renderMailbox()}
        <div className={'of-email-hosting-slider__main'}>
          <CustomSlider
            className={'of-slider'}
            min={1}
            max={25}
            value={value}
            tooltip={false}
            onChange={(val)=>{
              setValue(val)
            }}
            onChangeComplete={()=>{
              updateConfig(configurations,cid,{
                quantity: value
              },dispatch)
            }}
            setValue={setValue}
            initValue={value}
          />
        </div>
        {renderPrice()}
      </div>
      {renderButton()}
    </div>
  )
}
EmailHostingSlider = withRouter(EmailHostingSlider)
EmailHostingSlider.propTypes = {
  location: PropTypes.object,
  history: PropTypes.object
}

//main component
const EmailHostingConfig = () => {
  return (
    <div className={'of-step__wrapper of-email-hosting-config'}>
      <Heading className={'of-email-hosting-config__heading'}>Mailbox Quantity</Heading>
      <Description className={'of-email-hosting-config__description'}>Use the slider below to select the quantity of mailboxes {`you'd like`}.</Description>
      <EmailHostingSlider />
    </div>
  )
}

export default EmailHostingConfig
